import ScimApi from '@/api/scim'

const ACCOUNT_ACTOR_TYPE = 'Account'

// the return schema is below
// return {
//       data: rows,
//       pagination: {
//         total,
//         page,
//         limit,
//         totalPages,
//       },
//}

const scimApiKey = {
  namespaced: true,
  state: {
    apiKeys: [],
    pagination: null,
    isLoading: false,
  },
  mutations: {
    setApiKeys(state, { apiKeys, pagination }) {
      state.apiKeys = apiKeys
      state.pagination = pagination
    },
    setLoading(state, loading) {
      state.isLoading = loading
    },
  },
  actions: {
    async generateApiKey({ commit }, { accountId, metadata }) {
      commit('setLoading', true)
      try {
        const response = await ScimApi.generateApiKey({ 
            actorType: ACCOUNT_ACTOR_TYPE, 
            actorId: accountId,
            metadata: metadata || {}
        })
        return response
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
    async fetchApiKeys({ commit }, { active, page, limit, accountId }) {
      commit('setLoading', true)
      try {
        const { data: apiKeys, pagination } = await ScimApi.getApiKeys({ active, page, limit, accountId })
        commit('setApiKeys', { apiKeys, pagination })
      } catch (error) {
        console.error(error)
      } finally {
        commit('setLoading', false)
      }
    },
    async updateApiKey({ commit, dispatch, state }, { apiKeyId, active }) {
      commit('setLoading', true)
      try {
        const { data: apiKey } = await ScimApi.updateApiKey(apiKeyId, { active })
        // Refresh the current page data
        const { page = 1, limit = 40, active: currentActive } = state.pagination || {}
        await dispatch('fetchApiKeys', { 
          active: currentActive, 
          page, 
          limit, 
          accountId: state.pagination && state.pagination.accountId
        })
        return apiKey
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
    async updateApiKeyMetadata({ commit, dispatch, state }, { apiKeyId, metadata }) {
      commit('setLoading', true)
      try {
        const { data: apiKey } = await ScimApi.updateApiKey(apiKeyId, { metadata })
        // Refresh the current page data
        const { page = 1, limit = 40, active: currentActive } = state.pagination || {}
        await dispatch('fetchApiKeys', { 
          active: currentActive, 
          page, 
          limit, 
          accountId: state.pagination && state.pagination.accountId
        })
        return apiKey
      } catch (error) {
        console.error(error)
        throw error
      } finally {
        commit('setLoading', false)
      }
    },
    async deleteApiKey({ commit }, { apiKeyId }) {
      commit('setLoading', true)
      try {
        await ScimApi.deleteApiKey({ apiKeyId })
      } catch (error) {
        console.error(error)
      } finally {
        commit('setLoading', false)
      }
    },
  },
}

export default scimApiKey